import { DialogTitle, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

import { FontSizes } from '../../../core/config/mainTheme';

interface OwnProps {
  icon: React.ReactNode;
  title: string;
  handleClose: () => void;
  disabled?: boolean;
}

const DialogTitleBlock: React.FC<OwnProps> = ({ icon, title, handleClose, disabled = false }) => {
  const classes = useStyles();

  return (
    <DialogTitle className={classes.dialogTitle}>
      {icon}
      <Typography variant={'body1'}>{title}</Typography>
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={handleClose}
        disabled={disabled}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
};

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    display: 'flex',
    color: theme.palette.primary.dark,
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& svg: first-child': {
      marginRight: theme.spacing(2),
    },
    '& h2': {
      display: 'flex',
      alignItems: 'center',
      '& p': {
        fontWeight: 'bold',
        fontSize: FontSizes.modalTitleFont,
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(9),
      },
    },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(2),
    color: theme.palette.grey[500],
  },
}));

export default DialogTitleBlock;
